import { partsCataloguePath, productLibraryPath } from '@constants/routes';

const kitTab: string = 'kit';

interface KitURLParams {
  productId: string;
  externalId: string;
}

export const makeKitUrl = ({ productId, externalId }: KitURLParams) => {
  const unencodedURI = ['', productLibraryPath, productId, partsCataloguePath, kitTab, externalId];

  const url = unencodedURI.map(encodeURIComponent).join('/');

  return url;
};
